const e = {
  name: "Collapse",
  dimensions: { width: 20, height: 20 },
  content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7071 0.292893C19.3166 -0.0976311 18.6834 -0.0976311 18.2929 0.292893L13 5.58579V2C13 1.44772 12.5523 1 12 1C11.4477 1 11 1.44772 11 2V8C11 8.55229 11.4477 9 12 9H18C18.5523 9 19 8.55229 19 8C19 7.44772 18.5523 7 18 7H14.4142L19.7071 1.70711C20.0976 1.31658 20.0976 0.683418 19.7071 0.292893Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292894 19.7071C0.683417 20.0976 1.31658 20.0976 1.70711 19.7071L7 14.4142L7 18C7 18.5523 7.44772 19 8 19C8.55229 19 9 18.5523 9 18L9 12C9 11.4477 8.55229 11 8 11L2 11C1.44772 11 1 11.4477 1 12C1 12.5523 1.44772 13 2 13L5.58579 13L0.292894 18.2929C-0.0976312 18.6834 -0.0976312 19.3166 0.292894 19.7071Z" fill="currentColor"/>
    `
};
export {
  e as Collapse
};
